module.exports = __webpack_public_path__ + "media/images/pen_lerge-2d2142f6dfa8dfdcd9ae3193e993a22a.svg";